// biome-ignore lint/style/noExportedImports: these aren't re-exported
import { type DOMNode, Element, Text } from 'html-react-parser';
import type { ReactNode } from 'react';

export type { DOMNode, Element, Text };

export type DomElement = Extract<DOMNode, Element>;

export type DomText = Extract<DOMNode, Text>;

export function isElement(domNode: DOMNode): domNode is Element {
  return domNode instanceof Element;
}

export interface ParserProps {
  domNode: DomElement;
  reactNode: ReactNode;
}

export function isText(domNode: DOMNode): domNode is Text {
  return domNode instanceof Text;
}

export function exactClassLookUp(classList: string, lookup: string): boolean {
  return classList.split(' ').includes(lookup);
}

export function isExternalUrl(string: string): boolean {
  // ast-grep-ignore: no-absolute-fortune-urls
  const url = process.env.SITE_BASE_URL || 'https://fortune.com';
  try {
    return !/https:\/\/(?:.*\.)?fortune\.com/.test(new URL(string, url).origin);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      throw new Error(`Invalid url found while parsing node: [${error}]`);
    }
    return true;
  }
}
